import parse from 'color-parse'

export default function getContrastColor(color) {
  const [red, green, blue] = parse(color).values
  return red * 0.299 + green * 0.587 + blue * 0.114 > 186 ? '#000000' : '#ffffff'
}
